import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { SentimentNegativeOutlined, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import messageUtil from 'utils/messageUtil'
import SoundbiteSentiment from 'enums/SoundbiteSentiment'
import MetadataIconsContainer from './MetadataIconsContainer'
import { StyledSentimentContainer } from '../index.css'

type SentimentNegastiveIconProps = {
  annotated: boolean
}

const SentimentNegastiveIcon = ({ annotated }: SentimentNegastiveIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme

  const color = sys[theme].semantic.negative.default
  const message = messageUtil.sentimentSingular(SoundbiteSentiment.NEGATIVE)
  let tooltip = `${t('sentimentClassification')}: ${message}`
  let annotationMessage = ''
  if (annotated) {
    annotationMessage = `(${t('annotated')})`
    tooltip += ` ${annotationMessage}`
  }

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <StyledSentimentContainer>
        <MetadataIconsContainer message={message} annotationMessage={annotationMessage}>
          <SentimentNegativeOutlined color={color} />
        </MetadataIconsContainer>
      </StyledSentimentContainer>
    </Tooltip>
  )
}

export default SentimentNegastiveIcon
